<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :maskClosable="false" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-collapse v-model="activeKey">
        <a-collapse-panel key="1" header="商家信息" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="posType">
                <span slot="label"><a-tooltip>进件POS类型 <template slot="title">进件POS类型 —按接入系统做控制 </template></a-tooltip> </span>
                <a-input v-model="form.posType" disabled :maxLength="32" :placeholder="$t('请输入')+'机构代码'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="orgCode">
                <span slot="label"><a-tooltip>机构代码<template slot="title">机构代码 （合作方在拉卡拉的标识，请联系业务员</template></a-tooltip></span>
                <a-input v-model="form.orgCode" disabled :maxLength="32" :placeholder="$t('请输入')+'机构代码'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merRegName">
                <span slot="label"> <a-tooltip>商户注册名称<template slot="title">长度不小于4个汉字；营业执照商户可填营业执照名称（执照名称超过20个字的，注册名称可不与执照名称一致），小微商户入网不得含有"有限公司"。【8~40字符，不可为纯数字】</template></a-tooltip> </span>
                <a-input v-model="form.merRegName" :maxLength="80" :placeholder="$t('请输入')+'商户注册名称'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merBizName">
                <span slot="label"> <a-tooltip>商户经营名称<template slot="title">为空时，同商户注册名称，4-64个字符 【4~64字符，不可为纯数字】</template></a-tooltip> </span>
                <a-input v-model="form.merBizName" :maxLength="64" :placeholder="$t('请输入')+'商户经营名称'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merAreaxId">
                <span slot="label">  <a-tooltip>商户地区<template slot="title">商户地区</template></a-tooltip> </span>
                <a-cascader :options="areaList"
                            :field-names="{ label: 'areaName', value: 'areaId', children: 'children'}"
                            :placeholder="$t('请输入')+$t('所在地')"
                            style="width: 100%" v-model="areaSelected" allowClear @change="onAreaChange">
                </a-cascader>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merRegDistCode">
                <span slot="label">  <a-tooltip>商户地区代码<template slot="title">选择商户地区后自动带出拉卡拉地区代码，无需手工填写</template></a-tooltip> </span>
                <a-input v-model="form.merRegDistCode" disabled :maxLength="8" placeholder="选择商户地区后自动带出"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merRegAddr">
                <span slot="label"> <a-tooltip>商户详细地址<template slot="title">去除省，市，区后的详细地址，6-80字符</template></a-tooltip> </span>
                <a-input v-model="form.merRegAddr" :maxLength="80" :placeholder="$t('请输入')+'商户详细地址'"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="industryId" >
                <span slot="label" > <a-tooltip>主营行业<template slot="title">主营行业</template></a-tooltip></span>
                <a-cascader :options="industryList"
                            :field-names="{ label: 'categoryName', value: 'id', children: 'children'}"
                            :placeholder="$t('请选择')+'主营行业'"
                            style="width: 100%" v-model="industrySelected" allowClear @change="onIndustryChange">
                </a-cascader>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="mccCode">
                <span slot="label"> <a-tooltip>商户MCC编号<template slot="title">选择主营行业后自动带出银联 MCC，无需手工填写</template></a-tooltip></span>
                <a-input v-model="form.mccCode" disabled :maxLength="8" placeholder="选择主营行业后自动带出"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merBusiContent">
                <span slot="label"><a-tooltip>商户经营内容<template slot="title">商户经营内容</template></a-tooltip></span>
                <a-select v-model="form.merBusiContent" :placeholder="$t('请输入')+'商户经营内容'">
                  <a-select-option v-for="(item, index) in businessContentOptions" :value="item.type" :key="index">{{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.businessLicenseImg" >
                <span slot="label" ><a-tooltip>营业执照照片<template slot="title">营业执照照片 小微商户可不传，其它必传</template></a-tooltip> </span>
                <oss-upload-single v-model="form.fileDataResult.businessLicenseImg" :max-size="5" prefix="shop" type="img"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merBlisName">
                <span slot="label"> <a-tooltip>营业执照名称<template slot="title">1、主体为"小微/个人卖家"时，不填。2、主体为"个体工商户/企业"时，请上传营业执照。3、主体为"政府机关/事业单位/社会组织"时，请上传登记证书。</template></a-tooltip>  </span>
                <a-input v-model="form.merBlisName" :maxLength="80" :placeholder="$t('请输入')+'营业执照名称'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12" >
              <a-form-model-item prop="merBlis">
                <span slot="label"> <a-tooltip>营业执照号<template slot="title">营业执照号</template></a-tooltip> </span>
                <a-input v-model="form.merBlis" :maxLength="40" :placeholder="$t('请输入')+'营业执照号'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merBlisStDt">
                <span slot="label"> <a-tooltip>营业执照开始日期<template slot="title">营业执照开始日期</template></a-tooltip> </span>
                <a-date-picker style="width: 100%" v-model="form.merBlisStDt" valueFormat="YYYY-MM-DD" allow-clear/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merBlisExpDt">
                <span slot="label"> <a-tooltip>营业执照有效期<template slot="title">营业执照有效期 9999-12-31</template></a-tooltip> </span>
                <a-date-picker style="width: 80%" v-model="form.merBlisExpDt" valueFormat="YYYY-MM-DD" allow-clear/>
                <a @click="merBlisExpDtLong">长期?</a>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>
        <a-collapse-panel key="2" header="联系人信息" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="larName">
                <span slot="label"><a-tooltip>法人姓名<template slot="title">法人姓名</template></a-tooltip></span>
                <a-input v-model="form.larName" :maxLength="20" :placeholder="$t('请输入')+'法人姓名'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="larIdcard">
                <span slot="label"><a-tooltip>法人身份证号码<template slot="title">法人身份证号码</template></a-tooltip>        </span>
                <a-input v-model="form.larIdcard" :maxLength="40" :placeholder="$t('请输入')+'法人身份证号码'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.legalCardNational">
                <span slot="label"><a-tooltip>法人身份证国徽面<template slot="title">法人身份证国徽面</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.legalCardNational" prefix="shop" type="img"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.legalCardFace">
                <span slot="label"><a-tooltip>法人身份证人像面<template slot="title">法人身份证人像面</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.legalCardFace" prefix="shop" type="img"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="larIdcardStDt">
                <span slot="label"><a-tooltip>法人身份证开始日期<template slot="title">法人身份证开始日期</template></a-tooltip>        </span>
                <a-date-picker style="width: 100%" v-model="form.larIdcardStDt" valueFormat="YYYY-MM-DD" allow-clear/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="larIdcardExpDt">
                <span slot="label"><a-tooltip>法人身份证有效期<template slot="title">法人身份证有效期</template></a-tooltip>        </span>
                <a-date-picker
                  v-model="form.larIdcardExpDt"
                  style="width: 75%"
                  valueFormat="YYYY-MM-DD"
                  :disabled="larIdcardLongTerm"
                  allow-clear
                  @change="onLarIdcardExpDtChange"
                />
                <a-checkbox
                  v-model="larIdcardLongTerm"
                  @change="onLarIdcardLongTermChange"
                >长期</a-checkbox>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merContactName">
                <span slot="label"><a-tooltip>商户联系人<template slot="title">商户联系人</template></a-tooltip>        </span>
                <a-input v-model="form.merContactName" :maxLength="32" :placeholder="$t('请输入')+'商户联系人'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merContactMobile">
                <span slot="label"><a-tooltip>商户联系人手机<template slot="title">商户联系人手机号码</template></a-tooltip>        </span>
                <a-input v-model="form.merContactMobile" :maxLength="20" :placeholder="$t('请输入')+'商户联系人手机号码'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merContactEmail">
                <span slot="label"><a-tooltip>商户联系人邮箱<template slot="title">商户联系人邮箱</template></a-tooltip>        </span>
                <a-input v-model="form.merContactEmail" :maxLength="64" :placeholder="$t('请输入')+'商户联系人邮箱'"/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>
        <a-collapse-panel key="3" header="结算信息" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="acctTypeCode">
                <span slot="label"><a-tooltip>结算账户性质<template slot="title">结算账户性质</template></a-tooltip>        </span>
                <a-radio-group button-style="solid" v-model="form.acctTypeCode" :placeholder="$t('请输入')+'结算账户性质'">
                  <a-radio-button v-for="(item, index) in this.customDict.SettleAccountTypeEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-radio-button>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
<!--            <a-col :span="12">-->
<!--              <a-form-model-item prop="fileDataResult.bankCardImg">-->
<!--                <span slot="label"><a-tooltip>银行卡<template slot="title">银行卡图片</template></a-tooltip>        </span>-->
<!--                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.bankCardImg" prefix="shop" type="img"/>-->
<!--              </a-form-model-item>-->
<!--            </a-col>-->
            <a-col :span="12">
              <a-form-model-item prop="openingBankName">
                <span slot="label"><a-tooltip>结算账户开户行名称<template slot="title">结算账户开户行名称</template></a-tooltip>        </span>
                <a-button @click="$refs.RadioBranchSelectForm.openClearBranch(form.openingBankCode)" style="text-align: left; width: 100%" >
                  <span style="color: dodgerblue">{{this.getBranchName()}} </span>
                </a-button>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="openingBankCode">
                <span slot="label"><a-tooltip>结算账户开户行号<template slot="title">结算账户开户行号</template></a-tooltip>        </span>
                <a-input v-model="form.openingBankCode" disabled :maxLength="20" :placeholder="$t('请输入')+'结算账户开户行号'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="clearingBankCode">
                <span slot="label"><a-tooltip>结算账户清算行号<template slot="title">结算账户清算行号</template></a-tooltip>        </span>
                <a-input v-model="form.clearingBankCode" disabled :maxLength="20" :placeholder="$t('请输入')+'结算账户清算行号'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="acctNo">
                <span slot="label"><a-tooltip>结算账户账号<template slot="title">结算账户账号</template></a-tooltip>        </span>
                <a-input v-model="form.acctNo" :maxLength="40" :placeholder="$t('请输入')+'结算账户账号'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="acctName">
                <span slot="label"><a-tooltip>结算账户名称<template slot="title">1、选择经营者个人银行卡时，开户名称必须与身份证姓名一致。2、选择对公账户时，开户名称必须与营业执照上的"商户名称"一致。</template></a-tooltip>        </span>
                <a-input v-model="form.acctName" :maxLength="40" :placeholder="$t('请输入')+'结算账户名称'"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.settleCardNational">
                <span slot="label"><a-tooltip>结算人身份证国徽面<template slot="title">结算人身份证国徽面 ,不填的话 取法人身份证</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.settleCardNational" prefix="shop" type="img"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.settleCardFace">
                <span slot="label"><a-tooltip>结算人身份证人像面<template slot="title">结算人身份证人像面 ,不填的话 取法人身份证</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.settleCardFace" prefix="shop" type="img"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="acctIdcard">
                <span slot="label"><a-tooltip>结算人证件号码<template slot="title">结算人证件号码  为空时，判断为同法人 </template></a-tooltip>        </span>
                <a-input v-model="form.acctIdcard" :maxLength="40" :placeholder="$t('请输入')+'结算人证件号码'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="acctIdStDt">
                <span slot="label"><a-tooltip>结算人身份证开始日期<template slot="title">结算人身份证开始日期 为空时，判断为同法人</template></a-tooltip>        </span>
                <a-date-picker style="width: 100%" v-model="form.acctIdStDt" valueFormat="YYYY-MM-DD" allow-clear/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="acctIdDt">
                <span slot="label"><a-tooltip>结算人证件有效期<template slot="title">结算人证件有效期 为空时，判断为同法人</template></a-tooltip>        </span>
                <a-date-picker
                  v-model="form.acctIdDt"
                  style="width: 75%"
                  valueFormat="YYYY-MM-DD"
                  :disabled="acctIdLongTerm"
                  allow-clear
                  @change="onAcctIdDtChange"
                />
                <a-checkbox
                  v-model="acctIdLongTerm"
                  @change="onAcctIdLongTermChange"
                >长期</a-checkbox>
                <a @click="sameSettleLegal">结算人同法人?</a>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="settlePeriod">
                <span slot="label"><a-tooltip>结算周期<template slot="title">结算周期</template></a-tooltip>        </span>
                <a-select v-model="form.settlePeriod" :placeholder="$t('请输入')+'结算周期'">
                  <a-select-option v-for="(item, index) in customDict.SettleCycleEnum" :value="item.type" :key="index">{{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="limitAmount">
                <span slot="label"><a-tooltip>收款上限<template slot="title">不填表示不设上限 ,达到上限后将切换到下一个商户号</template></a-tooltip>        </span>
                <a-input-number v-model="form.limitAmount" style="width: 80%" :min="0" :max="9999999999" :step="0.01" placeholder="收款上限"  /><span>元</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="taxPointRange">
                <span slot="label"><a-tooltip>收款税点区间<template slot="title">例如0-1 或者 0.03-0.12 ,代表这个商户号只收这个税点区间的款 0.03≤税点≤0.12</template></a-tooltip>        </span>
                <a-input v-model="form.taxPointRange"   />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>

        <a-collapse-panel key="4" header="图片信息" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.doorImg">
                <span slot="label"><a-tooltip>商户门头照<template slot="title">商户门头照</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.doorImg" prefix="shop" type="img"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.interiorImg">
                <span slot="label"><a-tooltip>商铺内部照片<template slot="title">商铺内部照片</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.interiorImg" prefix="shop" type="img"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.offlinePaperAgreement">
                <span slot="label"><a-tooltip>线下纸质协议<template slot="title">线下纸质协议</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.offlinePaperAgreement" prefix="shop" type="null"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.networkAgreement">
                <span slot="label"><a-tooltip>电子协议<template slot="title">电子协议</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.networkAgreement" prefix="shop" type="null"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.cooperation">
                <span slot="label"><a-tooltip>合作资质证明<template slot="title">合作资质证明</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.cooperation" prefix="shop" type="null"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.foodBusiness">
                <span slot="label"><a-tooltip>食品经营相关资质<template slot="title">食品经营相关资质</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.foodBusiness" prefix="shop" type="null"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.unLegalSettleAuthorization">
                <span slot="label"><a-tooltip>非法人结算授权书<template slot="title">非法人结算授权书</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.unLegalSettleAuthorization" prefix="shop" type="null"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.cooperationAgreement">
                <span slot="label"><a-tooltip>合作协议<template slot="title"><a-button type="link" @click="downLoadTemp">下载模板</a-button></template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.cooperationAgreement" prefix="shop" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.otherFile">
                <span slot="label"><a-tooltip>其他<template slot="title">其他</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.otherFile" prefix="shop" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>
        <a-collapse-panel key="5" header="其他信息" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="contractId">
                <span slot="label"><a-tooltip>进件ID<template slot="title">进件ID</template></a-tooltip>        </span>
                <span>{{form.contractId}}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="contractStatus">
                <span slot="label"><a-tooltip>状态<template slot="title">状态</template></a-tooltip>        </span>
                <custom-dict-tag :options="customDict.ExtraApplyStatusEnum" :value="form.contractStatus"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="contractMemo">
                <span slot="label"><a-tooltip>进件描述<template slot="title">进件描述进件审核通过，返回"审核通过",进件审核驳回，返回具体的驳回理由。</template></a-tooltip>        </span>
                <span>{{form.contractMemo}}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merInnerNo">
                <span slot="label"><a-tooltip>拉卡拉内部商户号<template slot="title">拉卡拉内部商户号该属性审核通过才有</template></a-tooltip>        </span>
                <span>{{form.merInnerNo}}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merCupNo">
                <span slot="label"><a-tooltip>银联商户号<template slot="title">银联商户号该属性审核通过才有</template></a-tooltip>        </span>
                <span>{{form.merCupNo}}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>
      </a-collapse>

      <radio-branch-select-form ref="RadioBranchSelectForm" @branchSelect="indexBranchSelect"></radio-branch-select-form>
      <fee-rate-form ref="feeRateForm" @rateType="indexRateType"></fee-rate-form>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getExtraApplyLakala, addExtraApplyLakala, updateExtraApplyLakala} from '@/api/shop/extraApplyLakala'
import {getShop} from '@/api/shop/shop'
import {getApplyByShopId} from '@/api/shop/shopApply'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {areaListLakala} from "@/api/logistics";
import {listIndustry} from "@/api/shop/industry";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";
import RadioBranchSelectForm from '@/views/shop/branch/modules/RadioSelectForm'
import FeeRateForm from "@/views/shop/lakalaApply/modules/FeeRateForm.vue";

export default {
  name: 'CreateForm',
  props: {
    shopId: {
      type: String,
      required: true
    },
    shopType: {
      type: Number,
      required: true,
      default: 1
    }
  },
  components: {
    FeeRateForm,
    OssUploadSingle,
    CustomDictTag,
    RadioBranchSelectForm,
  },
  data() {
    return {
      labelCol: {span: 8},
      wrapperCol: {span: 16},
      submitLoading: false,
      formTitle: '请填写真实信息,否则将进件不成功',
      loading: '',
      activeKey: [1, 2, 3, 4, 5],
      areaList: [],
      areaSelected: [],
      // 商铺的省/市/区名称，用于新增第一个子商户时回显商户地区
      areaNames: null,
      industryList: [],
      industrySelected: [],
      larIdcardLongTerm: false,
      acctIdLongTerm: false,
      form: {
        id: null,
        shopId: this.shopId,
        orderNo: null,
        posType: "B2B_CASHIER_DESK",
        orgCode: '992782',
        merRegName: null,
        merBizName: null,
        merAreaxId: null,
        merRegDistCode: null,
        merRegAddr: null,
        mccCode: null,
        merBlisName: null,
        merBlis: null,
        merBlisStDt: null,
        merBlisExpDt: null,
        merBusiContent: undefined,
        larName: null,
        larIdType: "01",
        larIdcard: null,
        larIdcardStDt: null,
        larIdcardExpDt: null,
        merContactMobile: null,
        merContactName: null,
        merContactEmail: null,
        shopName: null,
        shopDistCode: null,
        shopAddr: null,
        shopContactName: null,
        shopContactMobile: null,
        openingBankCode: null,
        openingBankName: null,
        clearingBankCode: null,
        acctNo: null,
        acctName: null,
        acctTypeCode: null,
        settlePeriod: "T+1",
        acctIdType: "01",
        acctIdcard: null,
        acctIdStDt: null,
        acctIdDt: null,
        devSerialNo: null,
        devTypeName: null,
        termVer: null,
        salesStaff: null,
        termNum: null,
        feeDataList: null,
        fileDataList: null,
        contractNo: null,
        feeAssumeType: null,
        amountOfMonth: null,
        serviceFee: null,
        contractId: null,
        contractStatus: '0',
        contractMemo: null,
        merInnerNo: null,
        merCupNo: null,
        limitAmount: null,
        taxPointRange: '0-1',
        fileDataResult: {
          settleCardNational: null,
          settleCardFace: null,
          legalCardNational: null,
          legalCardFace: null,
          businessLicenseImg: null,
          bankCardImg: null,
          doorImg: undefined,
          interiorImg: undefined,
          offlinePaperAgreement: undefined,
          networkAgreement: undefined,
          cooperation: undefined,
          foodBusiness: undefined,
          unLegalSettleAuthorization: undefined,
          cooperationAgreement: undefined,
          otherFile: undefined,
        },
      },
      formType: 1,
      open: false,
      rules: {
        acctTypeCode: [{ required: true, message: '结算账户性质'+this.$t('不能为空'), trigger: 'change' }],
        posType: [{ required: true, message: '进件POS类型'+this.$t('不能为空'), trigger: 'change' }],
        orgCode: [{ required: true, message: '机构代码'+this.$t('不能为空'), trigger: 'change' }],
        merRegName: [{ required: true, message: '商户注册名称'+this.$t('不能为空'), trigger: 'blur' }],
        merBizName: [{ required: false, trigger: 'blur' }],
        merAreaxId: [{ required: false, message: '商户所在地'+this.$t('不能为空'), trigger: 'change' }],
        merRegDistCode: [{ required: true, message: '商户所在地'+this.$t('不能为空'), trigger: 'change' }],
        merBlis: [{ required: false, trigger: 'blur' }],
        merBlisName: [{ required: false, trigger: 'blur' }],
        merBlisStDt: [{ required: false, trigger: 'change' }],
        merBlisExpDt: [{ required: false, trigger: 'change' }],
        merRegAddr: [{ required: true, message: '商户注册地址'+this.$t('不能为空'), trigger: 'change' }],
        mccCode: [{ required: true, message: '商户行业'+this.$t('不能为空'), trigger: 'change' }],
        merBusiContent: [{ required: true, message: '商户经营内容'+this.$t('不能为空'), trigger: 'change' }],
        larName: [{ required: '结算人姓名'+this.$t('不能为空'), trigger: 'change' }],
        larIdType: [{ required: true, message: '结算人身份证类型'+this.$t('不能为空'), trigger: 'change' }],
        larIdcard: [{ required: true, message: '结算人身份证号'+this.$t('不能为空'), trigger: 'change' }],
        larIdcardStDt: [{ required: true, message: '结算人身份证开始日期'+this.$t('不能为空'), trigger: 'change' }],
        larIdcardExpDt: [{ required: true, message: '结算人身份证结束日期'+this.$t('不能为空'), trigger: 'change' }],
        acctIdStDt: [{ required: true, message: '结算人身份证开始日期'+this.$t('不能为空'), trigger: 'change' }],
        merContactMobile: [{ required: true, message: '商户联系人手机号'+this.$t('不能为空'), trigger: 'blur' }],
        merContactName: [{ required: true, message: '商户联系人姓名'+this.$t('不能为空'), trigger: 'blur' }],
        merContactEmail: [{ required: false, trigger: 'blur' }],
        openingBankCode: [{ required: true, message: '结算账户开户行代码'+this.$t('不能为空'), trigger: 'change' }],
        openingBankName: [{ required: true, message: '结算账户开户行名称'+this.$t('不能为空'), trigger: 'change' }],
        clearingBankCode: [{ required: true, message: '结算账户清算行代码'+this.$t('不能为空'), trigger: 'change' }],
        acctNo: [{ required: true, message: '结算账户号'+this.$t('不能为空'), trigger: 'change' }],
        acctName: [{ required: true, message: '结算账户名称'+this.$t('不能为空'), trigger: 'change' }],
        settlePeriod: [{ required: true, message: '结算周期'+this.$t('不能为空'), trigger: 'change' }],
        feeDataList: [{ required: true, message: '费率'+this.$t('不能为空'), trigger: 'change' }],
        fileDataResult: {}
      }
    }
  },
  computed: {
    ...mapGetters(['customDict']),
    businessContentOptions() {
      return this.customDict.ShopBusinessContentEnum || this.customDict.MerchantBusinessContentEnum || []
    }
  },
  created() {
    this.getAreaTree()
    this.getIndustryList()
  },
  methods: {
    getAreaTree() {
      areaListLakala().then(response => {
        this.areaList = response.data || []
        this.syncAreaSelection()
      })
    },
    onAreaChange(value, selectedOptions) {
      const selectedArea = selectedOptions && selectedOptions[selectedOptions.length - 1]
      this.form.merAreaxId = value && value.length ? value[value.length - 1] : null
      this.form.merRegDistCode = selectedArea && selectedArea.lakalaCode ? selectedArea.lakalaCode : null
    },

    getIndustryList() {
      // 店铺主体：个人=1、企业=2；行业主体：企业=1、个人=2。
      const merchantType = this.shopType === 1 ? 2 : 1
      listIndustry({ merchantType }).then(response => {
        this.industryList = response.data || []
        this.syncIndustrySelection()
      })
    },
    onIndustryChange(value, selectedOptions) {
      const selectedIndustry = selectedOptions && selectedOptions[selectedOptions.length - 1]
      this.form.mccCode = selectedIndustry ? selectedIndustry.unionPayMcc : null
    },
    findTreePath(nodes, predicate, path = []) {
      for (const node of nodes || []) {
        const currentPath = path.concat(node)
        if (predicate(node)) {
          return currentPath
        }
        const childPath = this.findTreePath(node.children, predicate, currentPath)
        if (childPath) {
          return childPath
        }
      }
      return null
    },
    syncAreaSelection() {
      if (!this.areaList.length) {
        return
      }
      // 编辑场景：按地区ID或拉卡拉代码匹配回显
      if (this.form.merAreaxId || this.form.merRegDistCode) {
        const areaId = this.form.merAreaxId
        const distCode = this.form.merRegDistCode
        const path = this.findTreePath(this.areaList, node =>
          (areaId != null && String(node.areaId) === String(areaId)) ||
          (distCode != null && String(node.lakalaCode) === String(distCode))
        )
        if (path) {
          const selectedArea = path[path.length - 1]
          this.areaSelected = path.map(node => node.areaId)
          this.form.merAreaxId = selectedArea.areaId
          if (selectedArea.lakalaCode) {
            this.form.merRegDistCode = selectedArea.lakalaCode
          }
          return
        }
      }
      // 新增首个子商户：按商铺省/市/区名称匹配回显
      if (this.areaNames && (this.areaNames.province || this.areaNames.city || this.areaNames.district)) {
        this.syncAreaSelectionByName(this.areaNames.province, this.areaNames.city, this.areaNames.district)
      }
    },
    /**
     * 按省/市/区名称在拉卡拉地区树中逐级匹配并回显商户地区
     */
    syncAreaSelectionByName(province, city, district) {
      if (!this.areaList.length || (!province && !city && !district)) {
        return
      }
      const match = (nodeName, targetName) => {
        if (!targetName) {
          return false
        }
        const n1 = String(nodeName || '').trim()
        const n2 = String(targetName).trim()
        if (n1 === n2) {
          return true
        }
        const strip = s => s.replace(/(省|市|区|县|自治区|特别行政区|地区|盟|自治州)$/g, '')
        return strip(n1) === strip(n2)
      }
      const provinceName = String(province || '').trim()
      const cityName = String(city || '').trim()
      const districtName = String(district || '').trim()

      const provinceNode = this.areaList.find(n => match(n.areaName, provinceName))
      if (!provinceNode) {
        return
      }
      // 匹配市（直辖市/市辖区时跳过市层，直接在省的子节点中找区）
      let leafNodes = provinceNode.children || []
      let cityNode = null
      if (cityName && cityName !== '市辖区' && !match(cityName, provinceName)) {
        cityNode = leafNodes.find(n => match(n.areaName, cityName))
      }
      if (cityNode) {
        leafNodes = cityNode.children || []
      }
      const districtNode = districtName ? leafNodes.find(n => match(n.areaName, districtName)) : null
      if (!districtNode) {
        return
      }
      this.areaSelected = [provinceNode.areaId]
      if (cityNode) {
        this.areaSelected.push(cityNode.areaId)
      }
      this.areaSelected.push(districtNode.areaId)
      this.form.merAreaxId = districtNode.areaId
      this.form.merRegDistCode = districtNode.lakalaCode || null
    },
    syncIndustrySelection() {
      if (!this.industryList.length || !this.form.mccCode) {
        return
      }
      const path = this.findTreePath(this.industryList, node =>
        node.unionPayMcc != null && String(node.unionPayMcc) === String(this.form.mccCode)
      )
      if (path) {
        this.industrySelected = path.map(node => node.id)
      }
    },
    syncSelections() {
      this.syncAreaSelection()
      this.syncIndustrySelection()
    },
    merBlisExpDtLong() {
      this.form.merBlisExpDt = '9999-12-31'
    },

    onLarIdcardLongTermChange(event) {
      this.form.larIdcardExpDt = event.target.checked ? '9999-12-31' : null
    },
    onLarIdcardExpDtChange(value) {
      this.larIdcardLongTerm = value === '9999-12-31'
    },
    onAcctIdLongTermChange(event) {
      this.form.acctIdDt = event.target.checked ? '9999-12-31' : null
    },
    onAcctIdDtChange(value) {
      this.acctIdLongTerm = value === '9999-12-31'
    },

    sameSettleLegal() {
      this.form.acctIdType = this.form.larIdType
      this.form.acctIdcard = this.form.larIdcard
      this.form.acctIdStDt = this.form.larIdcardStDt
      this.form.acctIdDt = this.form.larIdcardExpDt
      this.acctIdLongTerm = this.larIdcardLongTerm
      this.form.fileDataResult.settleCardFace = this.form.fileDataResult.legalCardFace
      this.form.fileDataResult.settleCardNational = this.form.fileDataResult.legalCardNational
    },

    /**
     * 结算人证件号码/有效期/身份证国徽面/人像面为空时，默认用法人的信息
     */
    fillSettleWithLegalDefault() {
      const fileData = this.form.fileDataResult || {}
      // 结算人身份证国徽面
      if (!fileData.settleCardNational && fileData.legalCardNational) {
        fileData.settleCardNational = fileData.legalCardNational
      }
      // 结算人身份证人像面
      if (!fileData.settleCardFace && fileData.legalCardFace) {
        fileData.settleCardFace = fileData.legalCardFace
      }
      // 结算人证件号码（为空时判断为同法人，证件类型也同步）
      if (!this.form.acctIdcard && this.form.larIdcard) {
        this.form.acctIdcard = this.form.larIdcard
        this.form.acctIdType = this.form.larIdType
      }
      // 结算人证件有效期（同时同步长期勾选状态）
      if (!this.form.acctIdDt && this.form.larIdcardExpDt) {
        this.form.acctIdDt = this.form.larIdcardExpDt
        this.acctIdLongTerm = this.larIdcardLongTerm
      }
      // 结算人身份证开始日期
      if (!this.form.acctIdStDt && this.form.larIdcardStDt) {
        this.form.acctIdStDt = this.form.larIdcardStDt
      }
    },

    getBranchName() {
      if (this.form.openingBankName) {
        return this.form.openingBankName
      } else {
        return this.$t('请选择')+'结算账户开户行名称'
      }
    },
    indexBranchSelect(record) {
      this.form.openingBankName = record.name;
      this.form.openingBankCode = record.code;
      this.form.clearingBankCode = record.clearingCode;
    },

    onClose() {
      this.cancel()
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.formType = 1
      this.larIdcardLongTerm = false
      this.acctIdLongTerm = false
      this.form = {
        id: null,
        shopId: this.shopId,
        orderNo: null,
        posType: "B2B_CASHIER_DESK",
        orgCode: '992782',
        merRegName: null,
        merBizName: null,
        merAreaxId: null,
        merRegDistCode: null,
        merRegAddr: null,
        mccCode: null,
        merBlisName: null,
        merBlis: null,
        merBlisStDt: null,
        merBlisExpDt: null,
        merBusiContent: undefined,
        larName: null,
        larIdType: "01",
        larIdcard: null,
        larIdcardStDt: null,
        larIdcardExpDt: null,
        merContactMobile: null,
        merContactName: null,
        merContactEmail: null,
        shopName: null,
        shopDistCode: null,
        shopAddr: null,
        shopContactName: null,
        shopContactMobile: null,
        openingBankCode: null,
        openingBankName: null,
        clearingBankCode: null,
        acctNo: null,
        acctName: null,
        acctTypeCode: null,
        settlePeriod: "T+1",
        acctIdType: "01",
        acctIdcard: null,
        acctIdStDt: null,
        acctIdDt: null,
        devSerialNo: null,
        devTypeName: null,
        termVer: null,
        salesStaff: null,
        termNum: null,
        feeDataList: null,
        fileDataList: null,
        contractNo: null,
        feeAssumeType: null,
        amountOfMonth: null,
        serviceFee: null,
        contractId: null,
        contractStatus: '0',
        contractMemo: null,
        merInnerNo: null,
        merCupNo: null,
        limitAmount: null,
        taxPointRange: '0-1',
        fileDataResult: {
          settleCardNational: null,
          settleCardFace: null,
          legalCardNational: null,
          legalCardFace: null,
          businessLicenseImg: null,
          bankCardImg: null,
          doorImg: undefined,
          interiorImg: undefined,
          offlinePaperAgreement: undefined,
          networkAgreement: undefined,
          cooperation: undefined,
          foodBusiness: undefined,
          unLegalSettleAuthorization: undefined,
          cooperationAgreement: undefined,
          otherFile: undefined,
        }
      }
      this.areaSelected = []
      this.industrySelected = []
      this.areaNames = null
    },

    indexRateType(list) {
      this.form.feeDataList = list
    },

    /** 新增按钮操作 */
    handleAdd(id, total) {
      this.reset()
      this.formType = 1
      if (total === 0) {
        getShop({ id }).then(response => {
          const shop = response.data || {}
          this.form.shopName = shop.shopName
          this.form.shopAddr = shop.shopAddress
          this.form.shopContactName = shop.contactsName
          this.form.shopContactMobile = shop.contactsPhone
          this.form.merRegName = shop.shopName
          this.form.merBizName = shop.shopName
          this.form.merRegAddr = shop.shopAddress
          // 营业执照号回显使用店铺的统一社会信用编码
          this.form.merBlis = shop.socialCreditCode
          this.form.merBlisName = shop.companyName
          // 营业执照照 = businessLicenceNumberElectronic(营业执照电子版)，不是 businessLicense(经营许可证书)
          this.form.fileDataResult.businessLicenseImg = shop.businessLicenceNumberElectronic
          this.form.larName = shop.contactsName
          this.form.larIdcard = shop.contactsCardNo
          this.form.fileDataResult.legalCardFace = shop.contactsCardFace
          this.form.fileDataResult.legalCardNational = shop.contactsCardCountry
          this.form.merContactName = shop.contactsName
          this.form.merContactMobile = shop.contactsPhone
          this.form.merContactEmail = shop.contactsEmail
          this.form.acctNo = shop.settlementBankAccountNumber
          this.form.acctName = shop.settlementBankAccountName
          this.form.openingBankName = shop.settlementBankName
          // 回显商户地区为商铺所在地（按省/市/区名称匹配拉卡拉地区树）
          this.areaNames = {
            province: shop.shopAreap,
            city: shop.shopAreac,
            district: shop.shopAreax
          }
          this.syncAreaSelection()
          // 法人信息回显后，立即给结算人四个空字段兜底（用法人值填充）
          this.fillSettleWithLegalDefault()
        })
      }
      this.form.feeDataList = [
        { "feeRatePct": 0, "feeLowerAmtPcnt": "0", "feeRateTypeCode": "303", "feeRateTypeName": "支付宝", "feeUpperAmtPcnt": "0" },
        { "feeRatePct": 0, "feeLowerAmtPcnt": "0", "feeRateTypeCode": "302", "feeRateTypeName": "微信", "feeUpperAmtPcnt": "0" }
      ]
      this.open = true;
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getExtraApplyLakala({ "id": id }).then(response => {
        this.form = response.data
        this.syncSelections()
        this.larIdcardLongTerm = this.form.larIdcardExpDt === '9999-12-31'
        this.acctIdLongTerm = this.form.acctIdDt === '9999-12-31'
        // 编辑场景：若结算人四个字段任一为空，仍用法人的值兜底
        this.fillSettleWithLegalDefault()
        this.open = true
      })
    },
    downLoadTemp() {
      window.open("https://static.byg1688.com/merchant/%E5%8C%85%E5%AE%9C%E8%B4%AD%E5%B9%B3%E5%8F%B0%E5%85%A5%E9%A9%BB%E7%AD%BE%E7%BA%A6%E5%8D%8F%E8%AE%AE.docx", "_blank")
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          // 结算人证件号码/有效期/身份证国徽面/人像面为空时，默认用法人的信息
          this.fillSettleWithLegalDefault()
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateExtraApplyLakala(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(this.$t('修改成功'), 3);
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addExtraApplyLakala(this.form).then(response => {
              this.$message.success(this.$t('新增成功'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="less">
.goods-collapse > .ant-collapse-header {
  color: #0e75d3 !important;
  background: #e8eef9;
}
</style>
